import React from 'react';

import { CreditCard } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { FullPageErrorState } from '@/modules/common/components/organisms/full-page-error-state';

const SUPPORT_URL = 'https://tally.so/r/VLJEYv';

/**
 * Full-screen error page shown when the user's subscription has expired
 * (backend error code 1100: ACCESS_ERROR_NO_ACTIVE_SUBSCRIPTIONS_FOUND).
 */
export const SubscriptionExpiredPage: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <FullPageErrorState
      icon={CreditCard}
      title={t('subscriptionExpired.title')}
      description={
        <Trans i18nKey="common:subscriptionExpired.description" components={{ bold: <strong /> }} />
      }
      showLogoutButton
      actions={
        <Button variant="default" asChild>
          <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer">
            {t('contactSupport')}
          </a>
        </Button>
      }
    />
  );
};
